import privateAPI from './privateAxiosInstance';

const downloadFile = async (link: string, filename: string) => {
  return await privateAPI
    .get(link, {
      responseType: 'blob',
    })
    .then((res) => {
      try {
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename + '.pdf');
        document.body.appendChild(link);
        link.click();
      } catch {
      }
    })
    .catch(() => null);
};

export default downloadFile;
